(function(){
'use strict';
console.log("OZ license script version","2.0.1-delayed-overlay");

const OZ_EP="https://pqlnfufpjcnepqcdcjpb.supabase.co/functions/v1/check-license";
const DEF_MSG="הרישיון של האתר אינו פעיל. אנא צרו קשר עם עומר זנו להסדרת התשלום והרישיון.";
const NO_KEY_MSG="No license key configured for this site. Please contact your developer.";
const OVERLAY_DELAY_MS=60000; // 60 seconds (1 minute) delay before showing overlay

let overlayTimeoutId=null;
let currentLicenseValid=false;

function ozClearOldCache(cfg){
  try{
    const k="oz_lc_"+(cfg.s||"x");
    const d=localStorage.getItem(k);
    if(d){
      const c=JSON.parse(d);
      if(c.v===true&&c.st==="error"){
        localStorage.removeItem(k);
      }
    }
    for(let i=0;i<localStorage.length;i++){
      const key=localStorage.key(i);
      if(key&&key.startsWith("oz_lc_")&&key!==k){
        localStorage.removeItem(key);
      }
    }
  }catch(e){}
}

function ozGetCache(cfg){
  try{
    const k="oz_lc_"+(cfg.s||"x");
    const c=localStorage.getItem(k);
    if(!c)return null;
    const d=JSON.parse(c);
    if(!d||!d.timestamp||Date.now()-d.timestamp>3600000*(d.refresh_after_hours||24))return null;
    return d;
  }catch(e){
    return null;
  }
}

function ozSetCache(cfg,res){
  try{
    const k="oz_lc_"+(cfg.s||"x");
    const d={
      v:res.valid,
      st:res.status,
      msg:res.overlay_message||DEF_MSG,
      refresh_after_hours:res.refresh_after_hours||24,
      timestamp:Date.now()
    };
    localStorage.setItem(k,JSON.stringify(d));
  }catch(e){}
}

function ozPing(cfg){
  if(!cfg.k){
    return Promise.resolve({
      valid:false,
      status:"error",
      overlay_message:NO_KEY_MSG,
      refresh_after_hours:1
    });
  }
  return fetch(OZ_EP,{
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify({
      shop_domain:cfg.s,
      license_key:cfg.k,
      theme_version:cfg.v,
      current_url:window.location.href
    })
  }).then(function(r){
    if(!r.ok)throw new Error("HTTP "+r.status);
    return r.json();
  }).catch(function(e){
    return{
      valid:false,
      status:"error",
      overlay_message:DEF_MSG,
      refresh_after_hours:1
    };
  });
}

function cancelOverlayTimeout(){
  if(overlayTimeoutId!==null){
    clearTimeout(overlayTimeoutId);
    overlayTimeoutId=null;
  }
}

function showOverlayDelayed(res,cfg){
  cancelOverlayTimeout();
  if(res.valid===true&&res.status==="active"){
    currentLicenseValid=true;
    ozApply(res,cfg);
    return;
  }
  currentLicenseValid=false;
  overlayTimeoutId=setTimeout(function(){
    if(!currentLicenseValid){
      ozApply(res,cfg);
    }
  },OVERLAY_DELAY_MS);
}

function ozApply(res,cfg){
  const layer=document.getElementById("oz_ui_layer");
  const layerMsg=document.getElementById("oz_ui_layer_msg");
  const warn=document.getElementById("oz_ui_warn");
  if(!layer||!layerMsg||!warn)return;
  
  const isValid=res.valid===true&&res.status==="active";
  const msg=res.overlay_message||DEF_MSG;
  
  if(cfg.d===true){
    if(!isValid){
      warn.textContent=msg;
      warn.style.display="block";
      layer.style.display="none";
      document.body.style.overflow="";
    }else{
      warn.style.display="none";
      layer.style.display="none";
      document.body.style.overflow="";
    }
  }else{
    if(!isValid){
      layerMsg.textContent=msg;
      layer.style.display="flex";
      warn.style.display="none";
      document.body.style.overflow="hidden";
    }else{
      layer.style.display="none";
      warn.style.display="none";
      document.body.style.overflow="";
    }
  }
}

function syncState(cfg){
  const cached=ozGetCache(cfg);
  if(cached){
    const res={
      valid:cached.v,
      status:cached.st,
      overlay_message:cached.msg
    };
    showOverlayDelayed(res,cfg);
    if(cached.v===true&&cached.st==="active"){
      setTimeout(function(){
        ozPing(cfg).then(function(res){
          ozSetCache(cfg,res);
          showOverlayDelayed(res,cfg);
        });
      },1000);
      return;
    }
  }
  ozPing(cfg).then(function(res){
    ozSetCache(cfg,res);
    showOverlayDelayed(res,cfg);
    ozClearOldCache(cfg);
  });
}

function initThemeCore(){
  const cfg=window.__oz_cfg;
  if(!cfg||!cfg.s){
    return;
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",function(){
      syncState(cfg);
    });
  }else{
    syncState(cfg);
  }
}

initThemeCore();
})();
